export default __webpack_public_path__ + "book_details-isbn13.434355e1.png";